// extracted by mini-css-extract-plugin
module.exports = {"html":"styles_html__MVAmR","resource":"styles_resource__t9bfc","content":"styles_content__vfAAk","buttonWrapper":"styles_buttonWrapper__fEjWV"};